// extracted by mini-css-extract-plugin
export default {"tagBackground":"RoleTag_tagBackground__MR7l0","deleteButton":"RoleTag_deleteButton__ExJWc"};